import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {EngineStatisticsService, StatisticsConfig, Partner} from '@tj/tj-dmp-lib-api';
import {MenuItem} from 'primeng/api';

@Component({
    selector: 'dmp-statistics',
    templateUrl: './statistics.component.html',
    styleUrls: ['./statistics.component.scss'],
    standalone: false
})
export class StatisticsComponent implements OnInit {
    breadcrumb = [
      {label: this.translate.instant('menu.statistics.label')}
    ];
    description = 'Statistique utilisateur';
    codeTenant: string;
    configs: StatisticsConfig[];
    config: StatisticsConfig;
    datastore: string = null;
    partner: string = null;
    currentPartners: Array<Partner> = [];
    selectedPartners: Array<Partner> = [];
    categories: MenuItem[] = [];
    selectedCategoryIcon: string;
    options: any[];
    selectedViewModes: string[];
    

  constructor(private readonly translate: TranslateService,
              private readonly engineStatisticsService: EngineStatisticsService,
              private readonly changeDetectorRef: ChangeDetectorRef) { 
    this.options = [
      {label: 'Tableau', icon: 'pi pi-table', value: 'table'},
      {label: 'Graphique', icon: 'pi pi-chart-line', value: 'chart'}
      ];
    this.selectedViewModes = this.loadSelectedViewModes();
  }

  private loadSelectedViewModes(): string[] {
    const stored = localStorage.getItem('statisticsOption');
    if (!stored) {
      return ['table', 'chart'];
    }
    try {
      const values: string[] = JSON.parse(stored).map((option: { value?: string } | string) =>
        typeof option === 'string' ? option : option.value
      );
      const modes = values.filter(value => value === 'table' || value === 'chart');
      return modes.length > 0 ? modes : ['table', 'chart'];
    } catch {
      return ['table', 'chart'];
    }
  }

  ngOnInit(): void {
    this.initCategories();
  }

  initCategories() {
    Object.values(StatisticsConfig.CategoryEnum).forEach(category => {
      this.categories.push({
        id: category,
        label: this.translate.instant('statistics.categories.' + category),
        icon: this.getIconOfCategory(category),
        items: []
      });
    });
  }

  onConfigChange(): void {
    if (!this.config) {
      return;
    }
    const category = this.categories.find(c => c.id === this.config.category);
    this.selectedCategoryIcon = category?.icon;
    localStorage.setItem('statisticsConfig', JSON.stringify({ code: this.config.code }));
    if (category?.icon) {
      localStorage.setItem('statisticsConfigIcon', JSON.stringify(category.icon));
    }
    this.changeDetectorRef.detectChanges();
  }

  

  change(event: any) {
    const previousDatastore = this.datastore;
    const datastore = event.group;
    this.datastore = datastore ? datastore.code : null;
    this.currentPartners = datastore ? datastore.partners : [];
    this.selectedPartners = event.partner
      ? (Array.isArray(event.partner) ? event.partner : [event.partner])
      : [];
    this.codeTenant = datastore ? datastore.code : null;
    if (previousDatastore !== this.datastore) {
      this.config = null;
    }
    this.loadAll();
  }

  private restoreConfigFromStorage(): void {
    const stored = localStorage.getItem('statisticsConfig');
    if (!stored || !this.configs) {
      return;
    }
    try {
      const parsed = JSON.parse(stored);
      const code = parsed.code ?? parsed;
      this.config = this.configs.find(c => c.code === code) ?? null;
      this.selectedCategoryIcon = localStorage.getItem('statisticsConfigIcon')
        ? JSON.parse(localStorage.getItem('statisticsConfigIcon'))
        : null;
    } catch {
      this.config = null;
    }
  }

  loadAll() {
    if (this.datastore) {
      const selectedConfigCode = this.config?.code;
      this.engineStatisticsService.getAllConfigUsingGET(this.datastore).subscribe(configs => {
        this.configs = configs;
        if (selectedConfigCode) {
          this.config = this.configs.find(c => c.code === selectedConfigCode) ?? null;
        } else {
          this.restoreConfigFromStorage();
        }
        if (this.config) {
          this.onConfigChange();
        } else {
          this.changeDetectorRef.detectChanges();
        }
      });
    }
  }

  isOptionSelected(optionValue: string) {
    return this.selectedViewModes.includes(optionValue);
  }

  /*
  * This method is used to prohibit the user from unselecting all options
  */
  optionGuard() {
    if (this.selectedViewModes.length == 0) {
      this.selectedViewModes = ['table'];
    }
    localStorage.setItem('statisticsOption', JSON.stringify(this.selectedViewModes.map(value => ({ value }))));
  }

  getIconOfCategory(category: StatisticsConfig.CategoryEnum) {
    if (category == StatisticsConfig.CategoryEnum.CONTACT) {
      return 'fa fa-user';
    }
    if (category == StatisticsConfig.CategoryEnum.SELL) {
      return 'fa fa-shopping-cart';
    }
    if (category == StatisticsConfig.CategoryEnum.FLIGHT) {
      return 'fa fa-plane';
    }
    else {
      return 'fa fa-question';
    }
  }
}
